export const getHomePlanUrl = (planName: string) => {
  return `/house-plans/${encodeURIComponent(planName.replaceAll("'", '').replaceAll(' ', '-').toLowerCase())}`;
};
